// extracted by mini-css-extract-plugin
export var checkboxContainer = "Checkbox-module--checkboxContainer--3kEum";
export var hiddenCheckbox = "Checkbox-module--hiddenCheckbox--15qwN";
export var styledCheckbox = "Checkbox-module--styledCheckbox--1xNUw";
export var icon = "Checkbox-module--icon--2Dqun";
export var hide = "Checkbox-module--hide--hUNr_";
export var show = "Checkbox-module--show--21ueN";